var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "135px",
    viewBox: "0 0 135 135",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#B2E4C1",
    cx: 67.5,
    cy: 67.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27, 26)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,0 C18.3453453,0 0,18.3453453 0,41 C0,63.6546547 18.3453453,82 41,82 C63.6546547,82 82,63.6546547 82,41 C82,18.3863864 63.6546547,0 41,0 L41,0 Z M62.956957,38.6606607 C62.7107107,40.7947948 60.9459459,40.6306306 60.9459459,40.6306306 C59.5095095,40.6306306 59.017017,39.4814815 59.017017,39.4814815 L56.0620621,32.955956 L50.6036036,56.5135135 C50.1521522,58.2372372 48.5515516,58.0730731 48.5515516,58.0730731 C47.1561562,58.0730731 46.7047047,56.8828829 46.7047047,56.8828829 L38.988989,38.5375375 L32.7097097,52.983984 C32.012012,54.1331331 30.8628629,54.1331331 30.8628629,54.1331331 C29.5085085,54.1331331 28.9339339,52.983984 28.9339339,52.983984 L24.8708709,45.022022 L20.1511512,50.6446446 C19.6996997,51.4654655 18.4684685,51.4654655 18.4684685,51.4654655 C16.5395395,51.4654655 16.4164164,49.5365365 16.4164164,49.5365365 C16.4164164,48.7567568 16.9499499,48.1411411 16.9499499,48.1411411 L23.6806807,40.2202202 C24.2962963,39.4404404 25.2812813,39.3993994 25.2812813,39.3993994 C26.6356356,39.3993994 27.2102102,40.5895896 27.2102102,40.5895896 L30.6576577,47.4024024 L37.1831832,32.5045045 C37.8398398,31.2732733 38.988989,31.3553554 38.988989,31.3553554 C40.3023023,31.3553554 40.8768769,32.5455455 40.8768769,32.5455455 L48.0590591,49.5365365 L53.3943944,26.3073073 C53.7637638,24.6656657 55.4874875,24.6656657 55.4874875,24.6656657 C56.6776777,24.6656657 57.2932933,25.8148148 57.2932933,25.8148148 L62.7517518,37.9219219 C62.997998,38.045045 62.956957,38.6606607 62.956957,38.6606607 L62.956957,38.6606607 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.7788747b42403836eac8ff0c31fbdcf6.svg";
export { ForwardRef as ReactComponent };